import { useEffect } from 'react'
import { useLocation, useParams } from 'react-router-dom'

import { useCoachCertification } from './useCoachCertification'
import CertificationNotice from './CertificationNotice'
import CertificationLoader from './CertificationLoader'
import CertificationHero from './CertificationHero'
import CertificationSummary from './CertificationSummary'
import CourseOutline from './CourseOutline'
import PriceCard from './PriceCard'
import ShareKitCard from './ShareKitCard'

import classes from './CertificationPage.module.scss'

const CertificationPage = () => {
  const { certificationId } = useParams()
  const { hash } = useLocation()
  const { certification, notFound, failed } = useCoachCertification(certificationId, { refresh: true })
  const enrollment = certification?.enrollment
  const loadedId = certification?.id

  useEffect(() => { if (loadedId && hash) { document.getElementById(hash.slice(1))?.scrollIntoView() } }, [loadedId, hash])

  if (notFound || failed) { return <CertificationNotice notFound={notFound} /> }
  if (!certification) { return <CertificationLoader /> }

  return (
    <main className={classes.page}>
      <CertificationHero certification={certification} />
      <div className={classes.body}>
        <div className='d-flex flex-column'>
          {enrollment?.status === 'completed' && <ShareKitCard certification={certification} />}
          <CertificationSummary certification={certification} />
          <CourseOutline certification={certification} />
        </div>
        <PriceCard certification={certification} />
      </div>
    </main>
  )
}

export default CertificationPage
